module.exports = __webpack_public_path__ + "static/media/webIcons-08.06efb4e9.svg";